import Index from "./Index"
export default Index
